import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { makeActive } from "../dataStore/slice/ActiveSlice";

// import listData from "./listdata";
import json from "./listData.json";
import Icons from "../MiscCompo/Icons";

const List = React.memo((props) => {
	const MenuList = json;
	const dispatch = useDispatch();
	const location = useLocation();
	let path = location.pathname;
	// console.log(path);

	// const q = useSearchParams();
	// const qdata = q[0].get("data");
	// console.log(qdata);
	// console.log(id);
	// console.log('-=-=-', props.actiid);

	const activeData = useSelector((store) => store.listActive);
	// console.log("&*&*&*&*&*&", activeData);

	// const [data, setData] = useState(null);

	/* useEffect(() => {
		console.log("useEffect start");
		// Fetch JSON data from the server
		fetch("http://localhost:1111/listdata") // Replace with the correct server URL
			.then((response) => response.json())
			// .then((jsonData) => console.log("-----------", jsonData))
			.then((jsonData) => setData(jsonData))
			.catch((error) => console.error("Error fetching data:", error, "123"));
	}, []); */

	// Get all elements with the specified attribute value
	const tonode = document.querySelectorAll(`[href="/fradoc?data=${activeData[0]}"]`);
	// console.log(tonode);

	let listnode = document.getElementById(`${activeData[0]}`);
	// console.log(listnode);

	useEffect(() => {
		if (path === "/fradoc" && activeData.length > 0) {
			// console.log("///////fradoc");
			ecadd(null, tonode[0]);
			ecloop(null, tonode[0]);
		} else if (listnode) {
			// console.log("/:iid");
			ecadd(null, listnode);
			ecloop(null, listnode);
		}
		if (props.flapcommand) {
			props.flapcommand("close");
		}
	});

	const ecloop = (e, navnode = null) => {
		if (e) {
			// e.preventDefault();
			// console.log(e.currentTarget.classList.toggle('jigar'));
			e.currentTarget.classList.toggle("drop");
			const elementsToRemoveClass = document.querySelectorAll(".childActive");
			// console.log(elementsToRemoveClass);
			// Iterate through the elements and remove the class
			elementsToRemoveClass.forEach((element) => {
				element.classList.remove("childActive");
			});
			e.currentTarget.classList.toggle("childActive");
		} else if (navnode) {
			// Get the button element
			// const button = document.querySelector(".child button");
			const activechild = document.querySelectorAll(".childActive");

			// Get the parent element with class "parent"
			// const parentAccordion = activechild[0].closest(".accordion");
			// const aMaster = parentAccordion.querySelectorAll(".aMaster");
			const parentAchild = activechild[0].closest(".aChild");
			const aMaster = parentAchild.previousElementSibling;
			aMaster.classList.add("drop");
		}
	};
	const ecadd = (e, navnode = null) => {
		// console.log("eeee", e);
		// console.log("node", navnode);
		if (e) {
			// e.preventDefault();
			const elementsToRemoveClass = document.querySelectorAll(".childActive");
			// console.log(elementsToRemoveClass);
			// Iterate through the elements and remove the class
			elementsToRemoveClass.forEach((element) => {
				element.classList.remove("childActive");
			});

			e.currentTarget.classList.add("childActive");
			dispatch(makeActive(null));
			if (props.togglef) {
				props.togglef();
			}
		} else if (navnode) {
			const elementsToRemoveClass = document.querySelectorAll(".childActive");
			// console.log(elementsToRemoveClass);
			// Iterate through the elements and remove the class
			elementsToRemoveClass.forEach((element) => {
				element.classList.remove("childActive");
			});

			navnode.classList.add("childActive");
			dispatch(makeActive(null));
			/* if (props.togglef) {
				props.togglef();
			} */
		}
	};

	/* const catchicon = (l, aMaster) => {
        // console.log('lll---', l , 'aMaster----',aMaster.className);
    } */
	return (
		// <div>
		<>
			{MenuList?.map((l, i) => {
				if (!l.list) {
					if (l.child) {
						return (
							<div key={i} className="accordion">
								{/* <Link className="aMaster" onClick={(e) => ecloop(e)} to={l.link}>
								<Icons geticon="pa-icon" />
								<p>{l.name}</p>
								<Icons geticon="dropdown-list" />
							</Link> */}
								<div className="aMaster" onClick={(e) => ecloop(e)} title={l.name} id={l.id} key={i}>
									<Icons geticon={l.icon ? l.icon : "pa-icon"} />
									<p>{l.name}</p>
									<Icons geticon="dropdown-list" />
									{/* <Icons geticon={catchicon(l, )} /> */}
								</div>
								<div className="aChild">
									{l?.child &&
										l.child.map((cl, i) => {
											return (
												<Link
													className={cl.status === "deploy" ? "childlist" : "childlist freeze"}
													data-skip-on-tab="true"
													key={i}
													id={cl.id}
													onClick={(e) => ecadd(e)}
													to={cl.status === "deploy" ? (cl["link-transit"] ? `${cl["link-transit"]}` : `${cl.link}?data=${cl.file}`) : null}
													state={{ path: cl.path }}
													// clickable={cl.status === "deploy" ? "true" : "false"}
													title={cl.name}
												>
													{/* <Icons geticon={l.child.length-1 === i ? "helinelast" : "heline"} /> */}
													<Icons geticon="heline" />
													<p>{cl.name}</p>
												</Link>
											);
										})}
								</div>
							</div>
						);
					} else {
						return (
							<Link className="aSingle" key={i} to={l.link} onClick={(e) => ecadd(e)}>
								<Icons geticon={l.icon ? l.icon : "pa-icon"} />
								<p>{l.name}</p>
							</Link>
						);
					}
				}
				return null;
			})}
		</>
	);
});

export default List;